import styled, { css } from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { FlexContainer, FlexContainerCentered } from "BaseComponents/Flex";

export const SearchFieldWrapper = styled(FlexContainer)`
  box-shadow: inset 0 6px 5px -5px rgb(0 0 0 / 62%);
  z-index: -1;
  transition: z-index 0.9s ease;

  &.open {
    z-index: 0;
  }
`;

export const SearchFieldInnerWrapper = styled(FlexContainerCentered)`
  height: 7rem;
`;
